/**
 * Sleep for {timeout} milliseconds.
 * @param timeout Milliseconds to sleep for
 * @returns A promise that resolves after timeout has expired
 */
export const sleep = (timeout = 0) =>
  new Promise((resolve) => setTimeout(resolve, timeout));
